module.exports = __webpack_public_path__ + "img/f4-1-1.28344324.png";